<template>
  <ContentWrap>
    <el-button type="primary" class="mb-12px" @click="openForm()">
      <Icon class="mr-5px" icon="ep:plus" />新增协议
    </el-button>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="ID" prop="id" width="80" />
      <el-table-column label="协议标题" prop="title" min-width="200" show-overflow-tooltip />
      <el-table-column label="添加时间" prop="createTime" width="170" :formatter="dateFormatter" />
      <el-table-column label="操作" width="100" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openForm(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>

  <el-dialog
    v-model="formVisible"
    :title="form.id ? '编辑协议' : '新增协议'"
    width="640px"
    @closed="resetForm"
  >
    <el-form ref="formRef" :model="form" :rules="formRules" label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" clearable maxlength="100" show-word-limit placeholder="协议标题" />
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="10"
          placeholder="协议正文"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitForm">保存</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import type { FormInstance, FormRules } from 'element-plus'
import * as LiveApi from '@/api/merchant/live'
import { dateFormatter } from '@/utils/formatTime'

defineOptions({ name: 'MerchantLiveAgreement' })

const message = useMessage()
const loading = ref(false)
const submitting = ref(false)
const list = ref<LiveApi.LiveAgreementVO[]>([])

const formVisible = ref(false)
const formRef = ref<FormInstance>()
const form = reactive<LiveApi.LiveAgreementVO>({
  id: undefined,
  title: '',
  content: ''
})
const formRules: FormRules = {
  title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
  content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
}

const getList = async () => {
  loading.value = true
  try {
    const data = await LiveApi.getLiveAgreementList()
    list.value = Array.isArray(data) ? data : []
  } finally {
    loading.value = false
  }
}

const openForm = (row?: LiveApi.LiveAgreementVO) => {
  if (row) {
    form.id = row.id
    form.title = row.title || ''
    form.content = row.content || ''
  }
  formVisible.value = true
}

const resetForm = () => {
  form.id = undefined
  form.title = ''
  form.content = ''
  formRef.value?.clearValidate()
}

const submitForm = async () => {
  await formRef.value?.validate()
  submitting.value = true
  try {
    await LiveApi.saveLiveAgreement({
      id: form.id,
      title: form.title,
      content: form.content
    })
    message.success('保存成功')
    formVisible.value = false
    await getList()
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  getList()
})
</script>
